const config = {
  baseURL: {
    local: "http://127.0.0.1:8000",
    develop:
      "https://time-tracker.825lk5bje5qli.ap-southeast-1.cs.amazonlightsail.com",
  },
};

export const baseURL = config.baseURL.develop;
